<template>
  <ReportDataTable
    :urls="urls"
    :mandatory-filter="[
      {
        name: 'date_range',
        title: 'Date range',
        valueFieldName: '.date',
      },
    ]"
  />
</template>

<script>
import ReportDataTable from "@/own/components/reports/ReportDataTable.vue";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
export default {
  name: "ReportMatrixAttemptsDelivered",
  components: { ReportDataTable },
  data: () => ({
    urls: {
      data_url: "/reports/matrixAttemptsDelivered",
      show_url: "/reports/matrixAttemptsDelivered/show",
    },
    page: "matrixAttempt",
  }),
  beforeMount() {
    this.$store.commit(SET_PAGE_LOADING, true);
  },
};
</script>
